import React from 'react'

import { Formik } from 'formik'

import { Button, Form, Modal, Col } from '_zari/core'

import { ValidationSchema } from '../_shared/validation'
import TipoFormGroup from '../_shared/formGroups/tipo'
import ComentarioFormGroup from '../_shared/formGroups/comentario'

const EXTENSIONES_PERMITIDAS = ['pdf', 'png', 'jpg', 'jpeg']
const MAX_BYTES = 10 * 1024 * 1024 // 10 MB

const NuevoDocumentoModal = ({ handleClose, show, agregarDocumento }) => {
  const formInitialValues = React.useMemo(
    () => ({
      tipo: '',
      comentario: '',
      file: null
    }),
    []
  )

  const submitHandler = async (data, { setFieldError }) => {
    if (!data.file) {
      setFieldError('file', 'Debe seleccionar un archivo.')
      return
    }
    const ext = data.file.name.split('.').pop().toLowerCase()
    if (!EXTENSIONES_PERMITIDAS.includes(ext)) {
      setFieldError('file', `Solo se aceptan archivos: ${EXTENSIONES_PERMITIDAS.join(', ')}`)
      return
    }
    if (data.file.size > MAX_BYTES) {
      setFieldError('file', 'El archivo supera 10 MB.')
      return
    }

    await agregarDocumento({
      tipo: data.tipo,
      file: data.file,
      comentario: data.comentario
    })
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>NUEVO DOCUMENTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
          <Form>
            <Modal.Body>
              <TipoFormGroup iError={errors.tipo} iTouched={touched.tipo} fIsSubmitting={isSubmitting} />
              <Form.Group>
                <Form.Label text='ARCHIVO' htmlFor='input-file-documento' md={3} />
                <Col md={9}>
                  <Form.InputFile
                    id='input-file-documento'
                    name='file'
                    disabled={isSubmitting}
                    onChange={e => setFieldValue('file', e.currentTarget.files[0] || null)}
                  />
                  {errors.file ? <div className='text-danger small mt-1'>{errors.file}</div> : null}
                  <div className='text-muted small mt-1'>Formatos: PDF, PNG, JPG. Tamaño máximo 10 MB.</div>
                </Col>
              </Form.Group>
              <ComentarioFormGroup
                iError={errors.comentario}
                iTouched={touched.comentario}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit} disabled={isSubmitting}>
                Adjuntar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoDocumentoModal
